import React from "react";

export default function InterdicaoVagoesFields({
  Section,
  DropdownField,
  DateDropdownField,
  form,
  onChange,
  sbOptions,
  motivoOptions,
  motivoOptionsVagoes,
  tipoOperacaoOptions,
  postoOrigemSosOptions,
  nivelAcionamentoOptions,
  kmHint,
  kmError,
}) {
  const vagoesMotivoOptions =
    Array.isArray(motivoOptionsVagoes) && motivoOptionsVagoes.length
      ?motivoOptionsVagoes
      : Array.isArray(motivoOptions)
        ?motivoOptions
        : [];

  return (
    <>
      <Section title="Operação">
        <div className="interdNova-grid interdNova-grid--3">
          <DateDropdownField
            label="Data"
            value={form.vagoesData}
            onChange={onChange("vagoesData")}
          />

          <label className="interdNova-field">
            <span>Horário início</span>
            <input
              type="time"
              value={form.vagoesHorarioInicio}
              onChange={onChange("vagoesHorarioInicio")}
            />
          </label>

          <label className="interdNova-field">
            <span>Trem</span>
            <input
              type="text"
              value={form.vagoesTrem}
              onChange={onChange("vagoesTrem")}
              placeholder="Ex.: V123"
            />
          </label>

          <DropdownField
            label="Seção de Bloqueio"
            value={form.vagoesSbParada}
            onChange={onChange("vagoesSbParada")}
            options={sbOptions}
            searchable
            searchInline
            preferredDirection="down"
            searchPlaceholder="Digite a seção de bloqueio"
            placeholder="Selecione a seção"
          />

          <label className="interdNova-field">
            <span>Km</span>
            <input
              type="text"
              className={kmError ?"interdNova-inputInvalid" : ""}
              value={form.vagoesKm}
              onChange={onChange("vagoesKm")}
              placeholder="125,300"
              aria-invalid={Boolean(kmError)}
            />
            {kmError ?(
              <small className="interdNova-fieldError">{kmError}</small>
            ) : kmHint ?(
              <small className="interdNova-fieldHint">{kmHint}</small>
            ) : null}
          </label>

          <label className="interdNova-field">
            <span>Nº Ativo</span>
            <input
              type="text"
              value={form.vagoesNumeroAtivo}
              onChange={onChange("vagoesNumeroAtivo")}
              placeholder="Ex.: 120345"
            />
          </label>

          <label className="interdNova-field">
            <span>Frota</span>
            <input
              type="text"
              value={form.vagoesFrota}
              onChange={onChange("vagoesFrota")}
              placeholder="Ex.: GDT"
            />
          </label>

          <DropdownField
            label="Tipo de operação"
            value={form.vagoesTipoOperacao}
            onChange={onChange("vagoesTipoOperacao")}
            options={tipoOperacaoOptions}
            placeholder="Selecione o tipo"
            preferredDirection="down"
          />

          <DropdownField
            label="Posto de origem do SOS"
            value={form.vagoesPostoOrigemSos}
            onChange={onChange("vagoesPostoOrigemSos")}
            options={postoOrigemSosOptions}
            placeholder="Selecione o posto"
            preferredDirection="down"
          />

          <label className="interdNova-field">
            <span>Mecânico acionado</span>
            <input
              type="text"
              value={form.vagoesMecanicoAcionado}
              onChange={onChange("vagoesMecanicoAcionado")}
              placeholder="Nome do mecânico"
            />
          </label>

          <DropdownField
            label="Nível de Acionamento"
            value={form.vagoesNivelAcionamento}
            onChange={onChange("vagoesNivelAcionamento")}
            options={nivelAcionamentoOptions}
            placeholder="Selecione o nível"
            preferredDirection="down"
          />

          <DropdownField
            label="Motivo"
            value={form.vagoesMotivo}
            onChange={onChange("vagoesMotivo")}
            options={vagoesMotivoOptions}
            placeholder="Selecione o motivo"
            searchable
            searchInline
            preferredDirection="down"
            searchPlaceholder="Digite o motivo"
            menuMaxHeight={164}
          />

          <label className="interdNova-field interdNova-field--full">
            <span>Obs.</span>
            <textarea
              rows="3"
              className="interdNova-observacao"
              value={form.vagoesObservacao}
              onChange={onChange("vagoesObservacao")}
              placeholder="Observações da interdição"
            />
          </label>
        </div>
      </Section>

      <Section title="Liberação">
        <div className="interdNova-grid interdNova-grid--3">
          <DropdownField
            label="Tem previsão?"
            value={form.vagoesTemLiberacao}
            onChange={onChange("vagoesTemLiberacao")}
            preferredDirection="up"
            options={[
              { value: "nao", label: "Não" },
              { value: "sim", label: "Sim" },
            ]}
          />

          {form.vagoesTemLiberacao === "sim" ?(
            <>
              <DateDropdownField
                label="Data liberação"
                value={form.vagoesDataLiberacao}
                onChange={onChange("vagoesDataLiberacao")}
              />

              <label className="interdNova-field">
                <span>Horário liberação</span>
                <input
                  type="time"
                  value={form.vagoesHorarioLiberacao}
                  onChange={onChange("vagoesHorarioLiberacao")}
                />
              </label>
            </>
          ) : null}
        </div>
      </Section>
    </>
  );
}
